module.exports = __webpack_public_path__ + "static/library2-6be2c8512975a1134c7ed71c4ac2823e.jpg";